import React, { PureComponent } from 'react';
import { Container } from 'react-bootstrap';
import Detail from './components/Detail';
import Banner from '../../components/Banner';
import Header from '../../components/Header';

class DetailContainer extends PureComponent {
  render() {
    const { location } = this.props;

    return (
      <Container fluid>
        <Banner />
        <Header />
        <Detail id={location.id} />
      </Container>
    );
  }
}

export default DetailContainer;
